import { FollowMemberButton } from "./follow-member-button";
import { useFollowMember } from "../../follow-member";
import { useToggleFollowMember } from "./use-toggle-follow-member";

export function FollowMemberButtonWrapper() {
  const { memberId, isFollowed, followingMessage, isSmall, followTitle, followingTitle } = useFollowMember();
  const { isSpinnerVisible, isUserFollowing, toggleClickHandler } =
    useToggleFollowMember({
      memberId,
      isFollowed,
      followingMessage,
    });

  return (
    <FollowMemberButton
      isFollowing={isUserFollowing}
      isLoading={isSpinnerVisible}
      disabled={isSpinnerVisible}
      toggleClickHandler={toggleClickHandler}
      isSmall={isSmall}
      followTitle={followTitle}
      followingTitle={followingTitle}
    />
  );
}
